var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 29,
    viewBox: "0 0 111 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.998047,
    y: 0.643555,
    width: 110,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_158_1086",
    transform: "scale(0.00909091 0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_158_1086",
    width: 110,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAAcCAYAAACAsYoxAAAElUlEQVRoBe1a7VHbQBClBP5kIpk/O3PiPyXQQegAOggdJB3gDkgHTgcuwSW4BEow83Ta80m6fXcSRoYQZjQn5JP24+2+3ZV9cbHAXy3NtpbmkDoqcQ8LqHBWEStpdinbjWsvlyKXZ1VYhX9l4K7k+sYAKBnI3d5H9d1Z168M3ErcnxnAbU8KWCXNLaitkuY3jpW4u0pEckLeCtw3ub6J5Xr5rR63p6QV2BLLqeX6J2zO2cc+r8XtLeBW0rxYn2X9CicYN7+oQgCIKVBLs6vE3ev+4ToHOChei1sz4yK9t5Z8Yt9O9ezozKzDsH0lzS/dX7p6v5m1/Rn2RTb0qBN6UznEsAOiDQpbD09c36YiZSpwiPRCwHrG1tJshvKJfW1gXom7T9gxfK7+v5uS4dDHevZ3aX7Av9bntTQhcZIAEsMO85zn9kPnTQGuluaJGKMOJGtfPrOvluZxhqynpCMHFz1jpLMtBoUxGaXpjGHEQaZSuCfQEOwpBQ6ZNsORKR1DcX8P+6hDOwBRKy1bKnHPijPTL96n+8PKbrQEl1zHc1VICXAicsmir0RmvEed+x72UYd2RrPZTXXD1lxmmtRcaljVDtEopm7tz2nGIQvCIFkCHItQUDb0VApGM5HX2629Y8zmK87Una+r7s53ytkWntYfPru5vQa0rsw/oHPd11sLHLCPI0Rv9pFit7pd9LdCmWIADM/kHVa6Y83o3tJ1Zg/A26hN8cr0gW0aRPE9es5mt1S2ZmptoH19frsyw3yk23MalGcNjCpZAlxPqcJ/WLsN2sVjmH0MAE/dNqukglnVZpSfui8nK0mXzDB1vCqUWnlkeufNAQ7KemDaIbgd+KFrfLDILgEOlJ+ySa9xANLvWHkwgfIx5I+PTE0M/YLqRiMSs0bYaJyw2qTOmwIcIpLtjxsQfp7PuFxgMj2U4oduYbMb19fO7nh8CPIyGZd9c5+LMAgqdcDEYT9uLhLnywOHTHoDOAkbjmCOKJYDd2zpA9KDE06Vfp4rAY5n7tGAcsecAzh7divX27LVd8nB/Qw4pCiiKGwenPgIo53lX9xSAhyrJzoOILsReXqwuqA0zew7NVVyfSxAiq+H8aqFgRnmo6T/Ckmx62iBfkGoL35zwPG5B633eBzI09KyGZez4e0Z1wJ8nOnywIWI2GBvt3/LxgBVUrM1B1zXkJgcD5kaMFgLMv2wdMbxDhffnhyZgp0zX+Gz4IcJwJmOVaDiNXY2Uwa1rTBatytxz+xZsfylgWNUn2KMAMDgJNPsHcJM9z7AeZpSnZizta0uyeA+MIEJjIBajipzzlbmUX+wFcM480VIiNMDN66JJcBlXvuY4NhGLgccm91yQ34KxIr/3MG/J80At5nSKUHJVHSVAAcDMnViAJ4PEHscWQY4X2/t7J9CkwpiQc2/pW9OtF324Nptvwds3PmpIqXAYb+f52xZoMs4QGwjlwKOz26hJqkzClebSRAkbl0EnMryTorfHeIHO/acp/fNWcey0NG6h7mOmKPDh76HUaVm3Ic24Ksq9x+4T4q8/+0gCv34aLn0k9r1r6v9CiE5zOICQTu3AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner4);
export default __webpack_public_path__ + "static/media/partner4.d5ba4f8abc04ccdbe2d12a785ac0c532.svg";
export { ForwardRef as ReactComponent };